import { getEmailFromUrl } from "../utils/scripts/getEmailFromUrl";
import getCurrencySymbol from "../utils/scripts/getCurrencySymbol";

function safeNumber(value: any): number | undefined {
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : undefined;
}

function resolveCurrency(info: Record<string, any>): string | undefined {
  if (typeof info.currency === 'string' && info.currency.length > 0) {
    return info.currency;
  }

  const fallback = getCurrencySymbol();
  return typeof fallback === 'string' && fallback.length > 0
    ? fallback
    : undefined;
}

export function routeMarketingEvent(event: { name: string; info?: Record<string, any> }) {
  if (!event?.name) return;

  const info = event.info ?? {};
  const action = info.quiz_action;

  const email = getEmailFromUrl();
  if (email && window.ttq) {
    window.ttq.identify({ email });
  }

  if (action === 'add_to_cart' && window.ttq) {
    const price = safeNumber(info.number_final_value ?? info.final_value);
    const currency = resolveCurrency(info);
    const contentId = info.product_name;

    window.ttq.track('InitiateCheckout', {
      content_type: 'product',
      content_id: contentId,
      quantity: 1,
      price,
      currency,
      value: price,
    });

    window.ttq.track('AddToCart', {
      content_type: 'product',
      content_id: contentId,
      quantity: 1,
      price,
      currency,
      value: price,
    });

  }

  if (action === 'open_checkout') {
    // Facebook
    if (window.fbq) {
      window.fbq('track', 'AddToCart');
    }

    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16857709798/QqzsC0fy6aUaEOb5sOY-',
      });
    }
  }

  if (action === 'payment_intention') {
    // TikTok
    if (window.ttq) {
      window.ttq.track('AddPaymentInfo');
    }

    // Facebook
    if (window.fbq) {
      window.fbq('track', 'AddPaymentInfo');
    }

    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16857709798/OhYTCMf_6aUaEOb5sOY-',
      });
    }
  }

  if (action === 'complete_payment' && window.ttq) {
    const price = safeNumber(info.number_complete_payment_value ?? info.complete_payment_value);
    const currency = resolveCurrency(info);
    const contentId = info.product_name_tt;
    const eventId = info.eventId;

    window.ttq.track('CompletePayment', {
      event_id: eventId,
      content_type: 'product',
      content_id: contentId,
      quantity: 1,
      price,
      currency,
      value: price,
    });

  }

  if (action === 'get_content_ids' && window.ttq) {
    const contentIds = info.content_ids;

    if (Array.isArray(contentIds) && contentIds.length > 0) {
      window.ttq.track('ViewContent', {
        content_type: 'product',
        content_ids: contentIds,
      });
    }

  }

  if (action === 'show_pdf_upsale' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_type: 'product',
      content_ids: info.content_ids_pdf,
    });
  }

  if (action === 'show_chat_upsale' && window.ttq) {
    window.ttq.track('ViewContent', {
      content_type: 'product',
      content_ids: info.content_ids_chat,
    });
  }

  if (action === 'payment_intention_pdf' && window.ttq) {
    const price = safeNumber(info.value);
    const currency = resolveCurrency(info);
    const contentId = info.pdf_product;

    window.ttq.track('InitiateCheckout', {
      content_type: 'product',
      content_id: contentId,
      quantity: 1,
      price,
      currency,
      value: price,
    });

    window.ttq.track('AddToCart', {
      content_type: 'product',
      content_id: contentId,
      quantity: 1,
      price,
      currency,
      value: price,
    });

    window.ttq.track('AddPaymentInfo');
  }

  if (action === 'payment_intention_chat' && window.ttq) {
    window.ttq.track('AddPaymentInfo');
  }

  if (window.gtag) {

    // payment_successful /
    if (action === 'payment_successful') {
      const value = safeNumber(
        info.complete_payment_value ?? info.number_complete_payment_value
      );

      window.gtag('event', 'conversion', {
        send_to: 'AW-16857709798/Gn50CKOK96UaEOb5sOY-',
        value,
        currency: resolveCurrency(info) ?? 'USD',
        transaction_id: info.eventId,
      });
    }
  }

}
